import React, { useEffect, useRef, useState } from 'react';

const ProductLogo = ({ src, size = 80 }: { src: string; size?: number }) => {
  const [isLoading, setIsLoading] = useState(true);
  const emptyLogo = '/product-logo-empty.svg';
  const imgSrc = src || emptyLogo;
  const errorRef = useRef(false);
  const roundSize = Math.floor(size / 6);

  useEffect(() => {
    const img = new Image();
    img.src = imgSrc;

    if (img.complete) {
      setIsLoading(false);
    } else {
      setIsLoading(true);
    }
    errorRef.current = false;
  }, [src, imgSrc]);

  return (
    <div
      className="box-border flex flex-shrink-0 items-center justify-center overflow-hidden bg-white"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: `${roundSize}px`,
        overflow: 'hidden'
      }}
    >
      <img
        alt="logo"
        style={{
          width: '100%',
          maxWidth: `${size}px`,
          maxHeight: `${size}px`,
          display: isLoading ? 'none' : 'block',
          padding: 0
        }}
        src={imgSrc}
        onLoad={(event) => {
          setIsLoading(false);
          const img = event.target as HTMLImageElement;
          img.style.padding = '0';
        }}
        onError={(event) => {
          const img = event.target as HTMLImageElement;
          if (!errorRef.current) {
            errorRef.current = true;
            img.src = emptyLogo;
          }
        }}
      />
      <div
        className="h-full w-full animate-pulse bg-gray-200"
        style={{
          display: isLoading ? 'block' : 'none'
        }}
      />
    </div>
  );
};

export default ProductLogo;
